import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary1: {
      main: '#347145' // Vert evs
    },
    primary: {
      main: '#eb5e28' // Orange evs
    },
    secondary: {
      main: '#F5F1EB', // beige doux
    },
    focus: {
      main: '#E2856E', // Saumon doux pour les éléments au focus (boutons, champs de texte, etc.)
    },
    grey: {
      main: '#8D99AE', // Gris foncé
    },
    validation:{
      main: '#629677', // Seagrass vert doux pour les validations et les succès
    },
    alerte:{
      main: '#F42C04', // Rouge vif pour les alertes et les erreurs
    },
    background: {
      default: '#f5f1eb', // Beige doux
      paper: '#ffffff', // Blanc pour les cartes et les dialogues
    },
  },
  typography: {
    fontFamily: 'Merriweather Sans, Inter, Roboto, Arial, sans-serif',
    h1: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 600,
      fontSize: '52px',
      '@media (max-width:600px)': {
        fontSize: '32px',
      },
      color: '#347145', // Bleu nuit
    },
    h2: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 500,
      fontSize: '34px' ,
      '@media (max-width:600px)': {
        fontSize: '24px',
      },
      color: '#347145', // Bleu nuit
    },
    h3: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 500,
      fontSize: '30px' ,
      '@media (max-width:600px)': {
        fontSize: '24px',
      },
      color: '#347145', // Bleu nuit
    },
    h4: {
      fontFamily: 'Merriweather Sans, sans-serif',
      fontWeight: 500,
      fontSize: '26px' ,
      '@media (max-width:600px)': {
        fontSize: '20px',
      },
      color: '#347145', // Bleu nuit
    },
    body1:{
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '20px',
      '@media (max-width:600px)': {
        fontSize: '16px',
      },
      fontWeight: 400,
    },
    body2:{
      fontFamily: 'Inter, Merriweather Sans, Roboto, sans-serif',
      fontSize: '16px',
      '@media (max-width:600px)': {
        fontSize: '14px',
      },
      fontWeight: 400,
      color: '#8D99AE', // Gris foncé
    },
    lineHeight: 1.5,
    button: {
      fontFamily: 'Merriweather Sans, Roboto, sans-serif',
      fontSize: '18px',
      '@media (max-width:600px)': {
        fontSize: '14px',
      },
      fontWeight: 500,
      color: '#f5f1eb',
      textTransform: 'none', // Pas de majuscules automatiques
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Pas de majuscules automatiques
          borderRadius: '10px', // Bordure arrondie
          px:3,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les cartes
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Ombre légère
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '10px', // Bordure arrondie pour les dialogues
          padding: '10px', // Espacement interne
          backgroundColor: '#ffffff', // Fond blanc pour les dialogues
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les sélecteurs
          '& .MuiSelect-icon': {
            color: '#347145', // Couleur de l'icône du sélecteur
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '10px', // Bordure arrondie pour les champs de texte
          '& .MuiInputBase-root': {
            borderRadius: '10px', // Bordure arrondie pour la racine du champ de texte
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#347145', // Couleur de la bordure au focus
          },
          '& .MuiInputLabel-root': {
            color: '#347145', // Couleur de l'étiquette du champ de texte
          }
        }
      }
    }
  },
});

export default theme;